module.exports = __webpack_public_path__ + "img/tamamlayici-saglik-sigortasi.ce61030d.png";